export interface WithDataTestId {
    'data-testid'?: string;
}

export const lowerEnvironments = [
    'local',
    'sit',
    'pat',
    'test',
    'dev',
    'development',
    'mock-app-environment',
] as const;

export const developmentEnvironments = ['local', 'dev', 'development'] as const;

export const produstionEnvironments = ['prod', 'production'] as const;

export const __brand = '__brand';
type Brand<B> = { [__brand]: B };
export type Branded<T, B extends string> = T & Brand<B>;
